function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Warning");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Warning",
  transform: "translate(1.000000, 1.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(35.000000, 35.000000) scale(-1, 1) translate(-35.000000, -35.000000) "
}, /*#__PURE__*/React.createElement("g", {
  id: "information-circle",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  stroke: "#F53C32"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 35,
  cy: 35,
  r: 34.6875
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(33.916667, 16.500000)",
  fill: "#F53C32",
  fillRule: "nonzero",
  id: "Path-3"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "2.08333333 0.5 2.08333333 24.5 0.08333333 24.5 0.08333333 0.5"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "2.08333333 30.5 2.08333333 36.5 0.08333333 36.5 0.08333333 30.5"
})))));

var SvgWarning = function SvgWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Warning.dc82fb86.svg";
export { ForwardRef as ReactComponent };